module.exports = __webpack_public_path__ + "static/media/big-play-button.3f5cd452.png";